import { FC, useRef } from 'react';
import { Modal } from 'react-bootstrap';

import ConditionsView from './ConditionsView';
import PlanTableView from './PlanTableView';

const BeneficiarySellModalBody: FC = () => {
  const printRef = useRef<HTMLDivElement>(null);

  return (
    <Modal.Body>
      <div
        className="invoice-wrap p-0 border-0"
        id="margin-print-only"
        ref={printRef}
      >
        <ConditionsView printRef={printRef} />

        <PlanTableView />
      </div>
    </Modal.Body>
  );
};

export default BeneficiarySellModalBody;
